<div class="emd-container" [ngStyle]="{ 'border-radius': radius.toString() + 'px' }">
    <div class="emd-container__content eu-clearfix" *ngIf="pageSizeOptionsList">
        <div class="emd-language-select eu-float_left">
            <select [(ngModel)]="pageSize" (change)="changePageSize()">
                <option
                    *ngFor="let pageSizeOption of pageSizeOptionsList"
                    value="{{ pageSizeOption }}"
                >
                    {{ pageSizeOption }} registros por página
                </option>
            </select>
            <div class="emd-language-select__arrow"></div>
        </div>
    </div>
    <div class="emd-container__footer">
        <div class="emd-pagination">
            <span class="emd-text _color_default"
                >Página {{ actualPage }} de {{ amountOfPages }}</span
            >
            <button
                type="button"
                class="emd-btn _color_primary _type_text"
                (click)="previousPage()"
                *ngIf="amountOfPages > 1"
                [disabled]="actualPage == 1"
            >
                Anterior
            </button>
            <button
                type="button"
                class="emd-btn _color_primary _type_text"
                (click)="nextPage()"
                *ngIf="amountOfPages > 1"
                [disabled]="actualPage == amountOfPages"
            >
                Próxima
            </button>
        </div>
    </div>
</div>
